import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first'

import { ITabInfo } from 'app/buffer-graph/models/tab-info-interface';
import {Moment} from "moment";
import {ItemInfo} from "./item-info";
import {OnDropdownFilteredEventArgs} from "../../slick-grid/models/on-dropdown-filtered-event-args";

export abstract class TabInfoBase<T> implements ITabInfo {
    protected constructor(header: string | Observable<string>, type: string, public readonly data: T, public itemInfo: ItemInfo, public startDate: Moment, public endDate: Moment, public readonly sharedGUID: string) {
        if (header instanceof Observable)
            header.first().subscribe((h: string) => this.hdr = h);
        else
            this.hdr = header;
        this.type = type
    }

    abstract id: string;
    public type: string;

// ReSharper disable once PrivateVariableCanBeMadeReadonly
    public dateChanged: boolean;
    public viewMode: boolean;
    public displayMode: boolean;
    public gridFilters: OnDropdownFilteredEventArgs<any>[];
    public sorting: {columnId: string, asc: boolean};
    public hdr: string;

    get header(): string {
        return this.hdr;
    }

    isActive: boolean;

}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tab-info-base.ts